import React from 'react';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <h2 className="section-title">ABOUT</h2>
        <div className="about-content">
          <p>
            Born from the underground, SloomWeep Productions is a fierce independent label dedicated to amplifying the raw, authentic voices of China's Stoner, Doom, Sludge, Heavy Psych, etc. Artists from all over the world are also welcome to join us.
          </p>
          <p>
            Our mission is to support independent artists who create music that moves slowly, hits hard, and takes you 
            on a journey through distorted landscapes and hypnotic rhythms.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;

